import Dexie, {Table} from 'dexie';

export type AttachmentTag = 'productComplaint' | 'xray'

export type Attachment = {
    id?: number,
    name: string,
    content: Blob,
    tag: AttachmentTag,
}

export class MySubClassedDexie extends Dexie {
    // 'friends' is added by dexie when declaring the stores()
    // We just tell the typing system this is the case
    attachments!: Table<Attachment>;

    constructor() {
        super('myDatabase');
        this.version(1).stores({
            attachments: '++id, name, content, size'
        });
    }
}

export const db = new MySubClassedDexie();

export const resetIndexedDb = async () => {
    const attachments = await db.attachments.toArray()
    await db.attachments.bulkDelete(attachments.map(a => a.id))
}
